<template>
  <div class="filedsContainer">
    <div class="head">
      <div class="title">商业公司</div>
      <div class="font-tip">编辑商户的资质字段信息</div>
    </div>
    <div class="body">
      <QFields :filedsList="filedsList" />
    </div>
    <div class="footer">
      <el-button type="primary" size="mini" @click="nextStep">下一步</el-button>
      <el-button size="mini">返回</el-button>
    </div>
  </div>
</template>
<script>
import QFields from "../components/qFields.vue";
export default {
  name: "CustomerFields",
  components: {
    QFields,
  },
  data() {
    return {
      filedsList: [
        {
          title: "营业执照",
          list: [
            {
              filedsName: "营业执照",
              filedsCheckedList: ["审核使用"],
            },
          ],
        },
        {
          title: "药品经营许可证",
          list: [
            {
              filedsName: "药品经营许可证",
              filedsCheckedList: [],
            },
          ],
        },
        {
          title: "法人委托书",
          list: [
            {
              filedsName: "法人委托书",
              filedsCheckedList: [],
            },
          ],
        },
        {
          title: "法人身份证",
          list: [
            {
              filedsName: "法人姓名",
              filedsCheckedList: [],
            },
            {
              filedsName: "法人身份证号",
              filedsCheckedList: [],
            },
          ],
        },
        {
          title: "不关联证件",
          list: [
            {
              filedsName: "负责人姓名",
              filedsCheckedList: [],
            },
            {
              filedsName: "负责人联系电话",
              filedsCheckedList: [],
            },
          ],
        },
        {
          title: "不关联证件",
          list: [
            {
              filedsName: "负责人姓名",
              filedsCheckedList: [],
            },
            {
              filedsName: "负责人联系电话",
              filedsCheckedList: [],
            },
          ],
        },
      ],
    };
  },
  methods: {
    nextStep() {
      console.log(this.filedsList, "this.filedsList");
    },
  },
};
</script>
<style lang='scss' scoped>
.filedsContainer {
  display: flex;
  flex-flow: column;
  height: 100%;
  overflow-y: auto;
  .head {
    background: #ffffff;
    height: 76px;
    padding: 10px;
    line-height: 28px;
  }
  .font-tip {
    padding-left: 20px;
    font-size: 12px;
  }
  .body {
    background: #ffffff;
    padding: 10px;
    margin-top: 10px;
    display: flex;
    flex: 1;
    overflow-y: auto;
  }
  .footer {
    padding: 20px;
    background: #ffffff;
  }
}
</style>